import { goSolidApi } from "@/composables/useGoSolidApi";

/** The signup path an account picks on the role selection page (`OnboardingStep` in app/models/account_models.py). */
export type OnboardingStep = "PRODUCER" | "CORPORATE";

export const signupApi = {
  /**
   * Records which signup path the account picked: `POST /api/account/onboarding-step`.
   *
   * @throws When the request fails; the signup pages hand that to the global error handler.
   */
  setOnboardingStep: async (step: OnboardingStep): Promise<void> => {
    await goSolidApi.post("/api/account/onboarding-step", {
      onboarding_step: step,
    });
  },
};
